export const environment = {
  env: 'uat',
  apiUrl: 'https://uatapi.theprodprocess.com/',
  backendUrl: 'http://uatportal.theprodprocess.com/',
  preBidUrl: 'http://uatportal.theprodprocess.com:8082/', 

  production: true,
};

export const cineburo_environment = {
  env: 'uat',
  apiUrl: 'https://uatportal.cineburo.com:8444/',
  backendUrl: 'http://uatportal.cineburo.com/',
  preBidUrl: 'https://uatportal.cineburo.com:8444/',
  production: true,
};

export const ent_environment = {
  env: 'uat',
  apiUrl: 'https://uatentapi.thelift.mx/',
  backendUrl: 'https://uatentportal.thelift.mx/',
  preBidUrl: 'http://uatentportal.thelift.mx:8082/',
  production: true
};


// WEBPACK FOOTER //
// ./src/environments/environment.uat.ts